
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/widget/calendar",
      function () {
        return require("private-next-pages/[publicId]/widget/calendar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/widget/calendar"])
      });
    }
  